<template>
  <div class="auth-loading-wrap"></div>
</template>

<script>
import store from "@/store";
import { Toast } from "vant";
export default {
  name: "AuthLoading",
  mounted() {
    this.testToken();
    Toast.loading({
      duration: 0, // 持续展示toast
      message: "登录中..."
    });
  },
  beforeDestroy() {
    Toast.clear();
  },
  methods: {
    testToken() {
      const { query } = this.$route;
      store.dispatch("user/fetchWxLoginByCode", query);
    }
  }
};
</script>

<style lang="scss"></style>
